import { useDispatch } from 'react-redux'
import { MapSettingsDrawer as Drawer } from 'ui-components'
import { useLayerTypeTitle } from '~map-preview/states/layerType'
import {
  closeMapSettingsDrawer,
  useIsMapSettingsDrawerOpen
} from '~map-preview/states/ui'
import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { Form } from './Form'

const MapSettingsDrawer = () => {
  const isEmbed = useIsEmbed()
  const dispatch = useDispatch()
  const open = useIsMapSettingsDrawerOpen()
  const title = useLayerTypeTitle()

  const handleClose = () => {
    dispatch(closeMapSettingsDrawer())
  }

  return (
    <Drawer
      isEmbed={isEmbed}
      title={title}
      open={open}
      onClose={handleClose}
      slots={{
        Form
      }}
    />
  )
}

export { MapSettingsDrawer }
